import styled from "styled-components";

export const StartStepWrapper = styled.section`
  margin: 0 auto;
  div {
    width: 100%;
    max-width: 600px;
    p {
      font-size: 18px;
      margin: 16px 0;
      box-sizing: border-box;
    }
  }

  div:last-of-type {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
  }

  * {
    margin: 8px;
  }
`;
